import { BuildGradientStyle } from '@utils/buildGradientStyle'
import { ReactNode } from 'react'

interface ModalHeaderProps {
    children: ReactNode
    gradientStyle?: BuildGradientStyle
    compact?: boolean
}

export const BonusModalHeader = ({ children, gradientStyle, compact = false }: ModalHeaderProps) => {
    return (
        <div
            id="bonus-modal-header"
            style={gradientStyle}
            className={`bg-gradient-to-r text-center flex items-center justify-center min-h-[65px]
                ${compact ? 'h-[65px]' : 'h-[88px]'}`}
        >
            {children}
        </div>
    )
}
